import React, { useRef } from 'react';
import css from './Var.module.css';
import logo from './../../../../assets/gabaritlogo.png';
import Barcode from 'react-barcode';
import { useReactToPrint } from 'react-to-print';
import { Button, Divider, Tag } from 'antd';
import { PrinterOutlined } from '@ant-design/icons';

function PrintNakl({ data, pr }) {
  let nakl = useRef();

  const handlePrint = useReactToPrint({
    content: () => nakl.current,
    documentTitle: 'Nakleyka', // Chop etilgan faylning nomi
    removeAfterPrint: true, // Chop etilgandan so'ng contentni olib tashlash
  });

  return (
    <>
      <Button onClick={handlePrint} style={{ backgroundColor: 'orange', color: 'white' }} icon={<PrinterOutlined />} />
      <div className={css.nakleyka} ref={nakl}>
        <div style={{ display: 'flex', gap: '20px', fontSize: '10px' }}>
          <img src={logo} alt="logo" />
          <div style={{ fontWeight: 'bold', paddingTop: '6px', flexDirection: 'column', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', fontSize: '12px' }}>
            <p>https://gabaritavto.uz</p>
            <p>Tel: +998915444898</p>
            <p>Ins: @gabarit_avto_market</p>
          </div>
        </div>
        <h3 style={{ textTransform: 'uppercase' }}>{data.product} {data.parametr}</h3>
        <div style={{ display: 'flex', gap: '20px', fontSize: '12px', fontWeight: 'bold', justifyContent: 'space-between', border: '1px solid #000', padding: '3px' }}>
          <span>{data.country}</span>
          <span>{data.manufacturer}</span>
        </div>
        <div style={{ margin: '3px 0' }}>
          {pr.brands.map(b => <span style={{ color: "black", fontWeight: 'bold', border: '1px solid black', padding: '2px', borderRadius: '5px', fontSize: '12px' }} key={b.id}>{b.nameuz}</span>)}
        </div>
        <div style={{ marginBottom: '3px' }}>
          {pr.models.map(b => <span style={{ color: "black", fontWeight: 'bold', border: '1px solid black', padding: '2px', borderRadius: '5px', fontSize: '12px' }} key={b.id}>{b.nameuz}</span>)}
        </div>
        <div className={css.barcode}>
          <Barcode format="CODE128" width={1} height={20} value={data.sku} />
          <h4 style={{ fontSize: '12px', textAlign: 'center' }}>{pr.category}</h4>
        </div>
      </div>
    </>
  );
}

export default PrintNakl;
